import React from 'react'

export const SingleProductCalculatorView = (props) => {
    return <div>
        <div>
            <label>Cost Price</label>
            <input name="cost" type="number" min="0" value={Number(props.singleProductObj.cost).toString()} step="0.01" onChange={(e) => { props.onChangeInput(e) }}></input>
        </div>
        <div>
            <label>Duty %</label>
            <select name="duty" value={props.singleProductObj.duty} onChange={(e) => { props.onChangeInput(e) }}>
                <option value={0}>0%</option>
                <option value={12}>12%</option>
            </select>
        </div>
        <div>
            <label>Cost Price Inc Duties</label>
            <div>£{props.singleProductObj.costPriceIncDuties.toFixed(2)}</div>
        </div>
        <div>
            <label>Weight</label>
            <input name="productWeight" type="number" min="0" max="2000" value={Number(props.singleProductObj.productWeight).toString()} onChange={(e) => { props.onChangeInput(e) }}></input>
        </div>
        <label>Cost Price Currency</label>
        {props.loaded && <select value={props.singleProductObj.currencyCode} onChange={(e) => { props.onChangeCurrencyCode(e) }}>
            <option value={'gbp'}>GBP</option>
            <option value={'eu'}>EUR ({props.exchangeRates.eu.currencyValue})</option>
            <option value={'usd'}>USD ({props.exchangeRates.us.currencyValue})</option>
        </select>}
        {props.loaded && <div>
            <label>Packaging</label>
            <select value={props.singleProductObj.packaging} onChange={(e) => { props.onChangePackaging(e) }}>
                {props.packaging.map((pack) => {
                    return <option value={pack.manufacturerCode}>{pack.packagingType.toUpperCase()} {pack.manufacturerCode}: £{pack.cost} / {pack.weight}g</option>
                })}
            </select>
        </div>}
        <div>
            <label>Large Letter or Box (Only affects UK)</label>
            <select name='largeLetter' value={props.singleProductObj.largeLetter} onChange={(e) => props.onChangeInput(e)}>
                <option value={false}>Box</option>
                <option value={true}>Large Letter</option>
            </select>
        </div>
        <div>
            {/* <label>Canada Sales Duty Rate</label>


            <select name='canadaSalesDutyRate' value={props.singleProductObj.canadaSalesDutyRate} onChange={(e) => { props.onChangeCanadaSalesDutyRate(e) }}>
                {props.categoryDutyRateOptions !== null && Object.keys(props.categoryDutyRateOptions).length !== 0 && Object.entries(props.categoryDutyRateOptions.ca).map((key, value) => {
                    console.log(key)
                    return <option value={key[1].rate}>{key[1].name} ({key[1].rate})%</option>
                })}
            </select> */}
        </div>
        <table>
            <tr>
                <th>Region</th>
                <th>Selling Price</th>
                <th>Ex-VAT GBP Price</th>
                <th>Product Weight (g)</th>
                <th>Packaging Weight</th>
                <th>Total Weight</th>
                <th>Product Cost</th>
                <th>Packaging Cost</th>
                <th>Bubble Wrap Cost</th>
                <th>Duty</th>
                <th>DDP Fee</th>
                <th>Shipping Cost</th>
                <th>Sales Fee</th>
                <th>Total Costs</th>
                <th>Profit £</th>
                <th>Profit $</th>
                <th>% Margin</th>
            </tr>
            {Object.keys(props.shippingData).map((region) => {
                const currencySymbols = {
                    'US': 'US$',
                    'ROW': 'US$',
                    'GB': '£',
                    'AU': 'AU$',
                    'CA': 'CA$',
                    // Default to '€'. You can add more regions and their symbols as needed.
                };
                return <tr>

                    {true && <>
                        <td>{region}</td>
                        <td>
                            {props.loaded &&
                                (currencySymbols[region] || '€') + props.regionalPrices[region]
                            }
                        </td>

                        <td>£{props.gbpRegionalPrice[region].toFixed(2)}</td>
                        <td>{props.singleProductObj.productWeight}g</td>
                        <td>{props.singleProductObj.packagingWeight}g</td>
                        <td>{parseFloat(props.singleProductObj.totalWeight) + parseFloat(props.singleProductObj.bubbleWrapPieceWeight)}g</td>
                        <td>£{props.singleProductObj.costPriceIncDuties.toFixed(2)}</td>
                        <td>£{props.singleProductObj.packagingCost.toFixed(2)}</td>
                        <td>£{props.singleProductObj.bubbleWrapPieceCost.toFixed(2)}</td>
                        <td>£{props.dutyAmounts[region.toLowerCase()].toFixed(2)}</td>
                        <td>£{props.salesDutyFees[region.toLowerCase()].toFixed(2)}</td>
                        <td>£{props.shippingData[region].totalCost.toFixed(2)}</td>
                        <td>£{props.transactionFee[region].toFixed(2)}</td>
                        <td>£{(props.totalCost[region] + props.transactionFee[region]).toFixed(2)}</td>
                        <td>£{(props.gbpRegionalPrice[region] - props.totalCost[region] - props.transactionFee[region] - props.dutyAmounts[region.toLowerCase()]).toFixed(2)}</td>
                        <td>${props.loaded && (((props.gbpRegionalPrice[region] - props.totalCost[region]) * props.exchangeRates.us.currencyValue).toFixed(2))}</td>
                        <td>{(((props.gbpRegionalPrice[region] - props.totalCost[region] - props.transactionFee[region] ) / props.gbpRegionalPrice[region]) * 100).toFixed(2)}%</td></>}

                </tr>
            })}

        </table>



    </div>

}